
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "TableHeader",
  props: {
    mapping: { type: Object as PropType<any>, required: true },
    sortBy: { type: Object as PropType<{ sortColumn: string; sortType: string }>, required: false },
    hasActions: { type: Boolean, default: false },
  },
  emits: ["sort"],
  methods: {
    colName(c: any) {
      return c.dbName ? c.dbName : c.name;
    },
    headerClass(c: any) {
      const cn = this.colName(c);
      const isSorted = this.sortBy?.sortColumn === cn;
      return {
        sortable: c.sortable,
        asc: isSorted && this.sortBy?.sortType === "asc",
        desc: isSorted && this.sortBy?.sortType === "desc",
      };
    },
    maybeSort(c: any) {
      if (c.sortable) this.$emit("sort", this.colName(c));
    },
  },
});
